import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SignIn from '../views/SignIn.vue'
import Register from '../views/Register.vue'
import Dashboard from '../views/Dashboard.vue'
import User_profile_edit from '../views/User_profile_edit.vue'
//import AdminCourseStates from '../views/AdminCourseStates.vue'
//import AdminCourseStatesAddEdit from '../views/AdminCourseStatesAddEdit.vue'
import Page404 from '../views/Page404.vue'
import store from '@/store'


import AdminDepartments from '../views/AdminDepartments.vue'
import AdminDepartment_edit from '../views/AdminDepartment_edit.vue'
import AdminCategories from '../views/AdminCategories.vue'
import AdminCourseStates from '../views/AdminCourseStates.vue'
import AdminChapterStates from '../views/AdminChapterStates.vue'

import AdminCourses from '../views/AdminCourses.vue'
import AdminCourse_show from '../views/AdminCourse_show.vue'
import AdminCourse_edit from '../views/AdminCourse_edit.vue'
import AdminCourse_chapters from '../views/AdminCourse_chapters.vue'
import AdminChapter_show from '../views/AdminChapter_show.vue'
import AdminChapter_edit from '../views/AdminChapter_edit.vue'
import AdminChapter_questions from '../views/AdminChapter_questions.vue'
import AdminQuestion_show from '../views/AdminQuestion_show.vue'
import AdminQuestion_edit from '../views/AdminQuestion_edit.vue'
import AdminQuestion_answers from '../views/AdminQuestion_answers.vue'
import AdminAnswer_edit from '../views/AdminAnswer_edit.vue'




import Courses from '../views/Courses.vue'
import Courses_inprogress from '../views/Courses_inprogress.vue'
import Courses_done from '../views/Courses_done.vue'
import Course_show from '../views/Course_show.vue'
import Chapter_show from '../views/Chapter_show.vue'

import Questions from '../views/Questions.vue'
import Question_show from '../views/Question_show.vue'




import User_show from '../views/User_show.vue'


import Departments from '../views/Departments.vue'
import Department_show from '../views/Department_show.vue'
//import Test from '../views/Test.vue'
//import Test2 from '../views/Test2.vue'

import Articles from '../views/Articles.vue'
import Article_show from '../views/Article_show.vue'


let if_not_authenticated_page = 'articles'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    // если не залогинены, пока не пускаем на главную тоже!
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: if_not_authenticated_page
        })
      }
      next()
    }
  },
  {
    path: '/signin',
    name: 'signin',
    component: SignIn,
    // если залогинены, то не пускаем на экран логина:
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        return next({
          name: 'dashboard'
        })
      }
      next()
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    // если залогинены, то не пускаем на экран регистрации:
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        return next({
          name: 'dashboard'
        })
      }
      next()
    }
  },

  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    // если не залогинены, то не пускаем на дашбоард:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },

  {
    path: '/user_profile_edit',
    name: 'user_profile_edit',
    component: User_profile_edit,
    // если не залогинены, то не пускаем на дашбоард:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },


/*
  _ OLD
  {
    path: '/admin/coursestates',
    name: 'adminCourseStates',
    component: AdminCourseStates,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },

  {
    path: '/admin/coursestates/:id/show',
    name: 'adminCourseStatesX',
    component: AdminCourseStates,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },


  {
    // тут недоделано
    path: '/admin/coursestates/add',
    name: 'adminCourseStatesAdd',
    props: {id: -1},
    component: AdminCourseStatesAddEdit,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },

  {
    // и тут недоделано
    path: '/admin/coursestates/:id/edit',
    name: 'adminCourseStatesEdit',
    component: AdminCourseStatesAddEdit,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },
*/

  { 
    path: '/404', 
    name: '404', 
    component: Page404,
  },
  {
    path: '*',
    redirect: '/404'
  },



  {
    path: '/admin/departments',
    name: 'adminDepartments',
    component: AdminDepartments,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },


  /*
    АДМИН Редактирование Кафедры.
  */
    {
      path: '/admin/departments/:id/edit',
      name: 'adminDepartment_edit',
      component: AdminDepartment_edit,
      // если не залогинены, то не пускаем:
      beforeEnter: (to, from, next) => {
        if (!store.getters['auth/authenticated']) {
          return next({
            name: 'signin'
          })
        }
        next()
      }
    },
  





  {
    path: '/admin/categories',
    name: 'adminCategories',
    component: AdminCategories,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },


  {
    path: '/admin/coursestates',
    name: 'adminCourseStates',
    component: AdminCourseStates,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },

  {
    path: '/admin/chapterstates',
    name: 'adminChapterStates',
    component: AdminChapterStates,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },




  {
    path: '/admin/courses',
    name: 'adminCourses',
    component: AdminCourses,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },









  /*
    АДМИН Просмотр курса.
  */
 {
  path: '/admin/courses/:id/show',
  name: 'adminCourse_show',
  component: AdminCourse_show,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},



  /*
    АДМИН Редактирование курса.
  */
  {
    path: '/admin/courses/:id/edit',
    name: 'adminCourse_edit',
    component: AdminCourse_edit,
    // если не залогинены, то не пускаем:
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'signin'
        })
      }
      next()
    }
  },



  /*
    АДМИН Список глав курса.
  */
 {
  path: '/admin/courses/:course_id/chapters',
  name: 'adminCourse_chapters',
  component: AdminCourse_chapters,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},





  /*
    АДМИН Просмотр главы.
  */
 {
  path: '/admin/chapters/:id/show',
  name: 'adminChapter_show',
  component: AdminChapter_show,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},


  /*
    АДМИН Редактирование главы.
  */
 {
  path: '/admin/chapters/:id/edit',
  name: 'adminChapter_edit',
  component: AdminChapter_edit,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},









  /*
    АДМИН Список вопросов главы.
  */
 {
  path: '/admin/chapters/:chapter_id/questions',
  name: 'adminChapter_questions',
  component: AdminChapter_questions,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},



  /*
    АДМИН Просмотр вопроса.
  */
 {
  path: '/admin/questions/:id/show',
  name: 'adminQuestion_show',
  component: AdminQuestion_show,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},



  /*
    АДМИН Редактирование вопроса.
  */
 {
  path: '/admin/questions/:id/edit',
  name: 'adminQuestion_edit',
  component: AdminQuestion_edit,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},







  /*
    АДМИН Список ответов на вопрос.
  */
 {
  path: '/admin/questions/:question_id/answers',
  name: 'adminQuestion_answers',
  component: AdminQuestion_answers,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},

  /*
    АДМИН Редактирование ответа.
  */
 {
  path: '/admin/answers/:id/edit',
  name: 'adminAnswer_edit',
  component: AdminAnswer_edit,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},












/*=============================

  Для пользователя.

 =============================*/

//
// Вывод списка Курсов.
//
{
  path: '/courses',
  name: 'courses',
  component: Courses,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},


//
// Вывод списка Курсов "в процессе прохождения".
//
{
  path: '/courses/iprogress',
  name: 'courses_inprogress',
  component: Courses_inprogress,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},

//
// Вывод списка завершённых Курсов.
//
{
  path: '/courses/done',
  name: 'courses_done',
  component: Courses_done,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},

//
// Отображаем Курс.
//
 {
  path: '/courses/:id',
  name: 'course_show',
  component: Course_show,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},


//
// Отображаем Главу.
//
{
  path: '/chapters/:id',
  name: 'chapter_show',
  component: Chapter_show,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},




//
// Отображаем список Вопросв к главе.
//
{
  path: '/chapters/:id/questions',
  name: 'questions',
  component: Questions,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},



//
// Отображаем Вопрос.
//
{
  path: '/questions/:id',
  name: 'question_show',
  component: Question_show,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},





//
// Отображаем инфу по Пользователю.
//
{
  path: '/users/:id',
  name: 'user_show',
  component: User_show,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},



//
// Список Кафедр.
//
{
  path: '/departments',
  name: 'departments',
  component: Departments,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},

//
// Отображаем инфу по Кафедре.
//
{
  path: '/departments/:id',
  name: 'department_show',
  component: Department_show,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},



/*
{
  path: '/test',
  name: 'test',
  component: Test,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},
*/

/*
{
  path: '/test2',
  name: 'test2',
  component: Test2,
  // если не залогинены, то не пускаем:
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
},
*/


//
//  Статьи
//
{
  path: '/articles',
  name: 'articles',
  component: Articles,
  // если залогинены, то не пускаем на экран логина:
  /*
  beforeEnter: (to, from, next) => {
    if (store.getters['auth/authenticated']) {
      return next({
        name: 'dashboard'
      })
    }
    next()
  }
  */
},


//
//  Одна статья.
//
{
  path: '/article/:id/show',
  name: 'article_show',
  component: Article_show,
  // если не залогинены, то не пускаем:
  /*
  beforeEnter: (to, from, next) => {
    if (!store.getters['auth/authenticated']) {
      return next({
        name: 'signin'
      })
    }
    next()
  }
  */
},

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
